import React from "react";
import { VelocityMark } from "../site/Logos";

export default function Logo({ size = 28, wordmark = true, compact = false, variant, className = "", testId }) {
  const showWord = wordmark && !compact && variant !== "icon";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid={testId || "brand-logo"}>
      <VelocityMark size={size} dark />
      {showWord && (
        <span className="font-cabinet font-black italic uppercase text-white" style={{ fontSize: size * 0.72, letterSpacing: "-0.04em" }}>
          ONTHE<span className="text-[#60A5FA]">PITCH</span>
        </span>
      )}
    </span>
  );
}
